import PricingForm from "../forms/pricingForm";

function Hero() {
  return (
    <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36">
    
      <img
        className="absolute w-full h-full object-cover z-10 top-0 left-0"
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/contactimg.jpeg"
        alt="Tło sekcji Bazy Wiedzy"
      />
      <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
      
      <div className="flex flex-col items-start justify-center gap-2 z-30 mb-6 lg:mb-0">
        <h2 className="text-white font-semibold text-sm uppercase tracking-wide">
          Drzewus - Blog i porady eksperckie
        </h2>
        <h1 className="text-3xl lg:text-6xl text-white font-bold">
          Baza wiedzy
        </h1>
        <h2 className="text-xl lg:text-3xl text-white mb-4 text-left">
          Zainspiruj się i poznaj tajniki naszej pracy
        </h2>
        
        <p className="text-white text-base lg:text-lg max-w-xl mb-6 opacity-90 text-start">
          Zapoznaj się z naszymi artykułami przygotowanymi przez specjalistów. 
          Piszemy o wycince drzew, bezpiecznym karczowaniu, nowoczesnym projektowaniu ogrodów i maszynach, 
          których używamy na co dzień. Sprawdź, co warto wiedzieć!
        </p>
      </div>

      <div className="z-30 max-w-[500px] flex flex-col items-center justify-center w-full mt-10 lg:mt-0">
        <PricingForm />
      </div>
    </section>
  );
}

export default Hero;